const hideScrollBar = {
  scrollbarWidth: 'none', // Firefox
  msOverflowStyle: 'none', // IE 10+
  '&::-webkit-scrollbar': {
    display: 'none', // Chrome, Safari
  },
};
export const hoverScrollBar = {
  ...hideScrollBar,
  '&:hover': {
    scrollbarWidth: 'auto', // Firefox
    msOverflowStyle: 'auto', // IE 10+
    '&::-webkit-scrollbar': {
      display: 'block', // Chrome, Safari
    },
    paddingRight: '6px',
  },
};
